// Card.jsx
import React, { useState, useEffect } from "react";
import Modal from "../modal/Modal";
import { useDispatch, useSelector } from "react-redux";
import {
  addToCart,
  decreaseCart,
  incrementCart,
} from "../../store/reducers/cartSlice";

function Card({ data }) {
  const [isOpen, setIsOpen] = useState(false);
  const dispatch = useDispatch();
  const cart = useSelector((state) => state.cart);

  function closeModal() {
    setIsOpen(false);
  }

  function openModal() {
    setIsOpen(true);
  }

  const handleAddToCart = (product) => {
    dispatch(addToCart(product));
  };

  const Cart = cart.cartItems.find((cartItem) => cartItem.id === data.id);

  // Optional: useEffect to do something when data prop changes, if needed

  return (
    <>
      <div className="group box-border overflow-hidden flex rounded-md shadow-sm flex-col items-center bg-white relative">
        <div
          onClick={openModal}
          className="relative flex justify-center w-full cursor-pointer"
        >
          {/* {data.discount && data.discount > 0 && (
            // <span className="absolute text-dark text-xs bg-orange-500 text-white py-1 px-2 rounded font-medium z-10 right-4 top-4">
            //   {Math.ceil(data.discount)}% Off
            // </span>
          )} */}
          <img
            src={data.image}
            alt={data.title}
            className="object-cover transition duration-150 ease-linear transform group-hover:scale-105 w-40 h-40 sm:w-44 sm:h-44 md:w-48 md:h-48"
          />
        </div>
        <div className="w-full px-3 lg:px-4 pb-4 overflow-hidden">
          <div className="relative mb-1">
            <h2 className="text-heading truncate mb-0 block text-sm font-medium text-gray-600">
              <span className="line-clamp-2">{data.title}</span>
            </h2>
          </div>
          {/* maybe price or other info here */}
        </div>
      </div>
      <Modal data={data} isOpen={isOpen} closeModal={closeModal} />
    </>
  );
}

export default Card;